<!-- 组件说明 -->
<template>
<div>
    <div class="container"  >
    <div class="pro-commom" v-if="goodsType == 1" >
      <ul >
        <li >
          <span class="title">商品名称</span>
          <p>{{gooodsDetail.commName}}</p>
        </li>
        <li >
          <span class="title">规格</span>
          <p>{{gooodsDetail.specification}}</p>
        </li>
        <li >
          <span class="title">生产厂商</span>
          <p>{{gooodsDetail.manufacturer}}</p>
        </li>
        <li >
          <span class="title">批准文号</span>
          <p>{{gooodsDetail.approval}}</p>
        </li>
        <li >
          <span class="title">剂型</span>
          <p>{{gooodsDetail.jixing}}</p>
        </li>
        <li >
          <span class="title">整件规格</span>
          <p>{{ gooodsDetail.jlgg }}{{gooodsDetail.unit}}</p>
        </li>
        <li >
          <span class="title">货号</span>
          <p>{{gooodsDetail.sn}}</p>
        </li>
        <li >
          <span class="title">中包装</span>
          <p>{{gooodsDetail.zybz}}{{gooodsDetail.unit}}</p>
        </li>
        <li >
          <span class="title">有效期至</span>
          <p style="color:#fa4b4b">{{gooodsDetail.expireDate}}</p>
        </li>
        <li >
          <span class="title">是否拆零</span>
          <p>{{gooodsDetail.zhxs?'否':'是'}}</p>
        </li>
      </ul>
    </div>
    <div class="pro-meal" v-if="goodsType == 2">
      <div class="meal-box c-pointer" v-for="(item,index) in gooodsDetail.goodsCombinationItemResults" :key="index" @click="todetail(item.goodsId)"> 
        <div class="l">
          <img v-lazy="item.image ?item.image:$defaultImg" alt="" />
        </div>
        <div class="r">
          <p class="t">{{item.name}}</p>
          <p class="b">
            <span>×{{item.quantity}}</span>
            <span>{{item.manufacturer}}</span>
          </p>
        </div>
      </div>

    </div>
  </div>
</div>
</template>
<script>
//import x from ''
export default {
  components: {},
  props:['gooodsDetail','goodsType'],
  data() {
    return {
      type: 1, //类型1普通商品  类型2套餐商品
    };
  },
  computed: {},
  methods: {
    todetail(id){
       this.$router.push({name:'detail',query:{goodsId:id ,type:1}})
    },
    isZGS(name) {
      return name.indexOf('珍贵膳') != -1
    },
  },
};
</script>
<style lang='scss' scoped>
.container {
  width: 512px;
}
.pro-commom {
    overflow: hidden;
  ul{
    display: flex;
    flex-wrap: wrap;
    background: #fafafa;
    padding:10px 20px;
    margin-bottom: 32px;
  }
  ul li {
    display: flex;
    width: 50%;
    margin: 10px 0;
    .title {
      display: inline-block;
      width: 60px;
      text-align-last: justify;
      margin-right: 20px;
      font-size:14px ;
      color: #808080;
      white-space: nowrap;
    }
    p{
        font-size: 13px;
        color: #505050;
        padding-right: 16px;
    }
  }
}
.pro-meal {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 20px 0 30px 0;
  .meal-box {
    width: 250px;
    height: 90px;
    border: 1px solid #f2f2f2;
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .l {
      height: 72px;
      width: 72px;
      flex-shrink: 0;
      img {
        @include size(100%, 100%);
      }
    }
    .r {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 18px 10px 10px;
      height: 90px;
      width: 177px;
      .t {
        font-size: 13px;
        color: #505050;
        @include textLineClamp(2)
      }
      .b {
      //  width: 250px;
        span {
            display: block;
          font-size: 12px;
          color: #999999;
         
           @include textLineClamp(1);
          &:nth-child(1) {
            font-size: 14px;
            color: #fa4b4b;
            margin-bottom: 8px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/detail/components/goods-change.vue